module.exports = __webpack_public_path__ + "img/logo-kigun.5d3a9408.svg";